import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import IconContentCard from "../components/shared/IconContentCard";
import { MdAccountBalance, MdEditLocation, MdError } from "react-icons/md";
import { BsDeviceSsd } from "react-icons/bs";
import { FaFileSignature, FaPassport, FaUser } from "react-icons/fa6";
import { GiPylon } from "react-icons/gi";
import { FaCheckCircle } from "react-icons/fa";
import ServerErrorComponent from "../components/inquary/ServerErrorComponent";
import AnlagenComponent from "../components/inquary/AnlagenComponent";
import PersonalComponent from "../components/inquary/PersonalComponent";
import AddressComponent from "../components/inquary/AddressComponent";
import SepaComponent from "../components/inquary/SepaComponent";
import SignatureComponent from "../components/inquary/SignatureComponent";
import PersonalIdComponent from "../components/inquary/PersonalIdComponent";
import ElvRegisterComponent from "../components/inquary/ElvRegisterComponent";
import DoneComponent from "../components/inquary/DoneComponent";
import SplashPage from "./SplashPage";

const RegistrationPage = () => {

    const navigate = useNavigate();
    const [apiError, setApiError] = useState("");
    const customer = JSON.parse(localStorage.getItem('customer'));
    const [step, setStep] = useState(1); // customer.qr_code === null? 2 : 1
    const [data, setData] = useState({});

    useEffect(() => {
        
        if (customer === null || customer === undefined) {
            return navigate("/");
        }
        else {

            setData({
                mailRegister: customer.mailRegister? true : false,
                qr_code: customer.qr_code !== null? customer.qr_code : "",
                anlagen: [],
                case: customer.change_or_new,
                situation: customer.situation,
                redeem_code: customer.redeem_code,
                partner: {
                    id: customer.id !== undefined && customer.id !== null? customer.id : null,
                    company_type: customer.company_type,
                    noFn: false,
                    noVat: false,
                    x_firmenbuch_nr: "",
                    vat: '',
                    x_anrede: customer.x_anrede && customer.x_anrede !== null? customer.x_anrede : "",
                    title: customer.title && customer.title !== null && customer.title.length > 0? customer.title[0].toString() : "",
                    name: customer.name,
                    lastName: customer.last_name !== null? customer.last_name : customer.last_name ,
                    x_title_postfix: customer.x_title_postfix && customer.x_title_postfix !== ""? customer.x_title_postfix : "",
                    x_birthdate: customer.x_birthdate,
                    email: customer.email,
                    mobile: customer.mobile,
                    differentAddress: customer.qr_code !== null && customer.qr_code !== "" ? false : true,
                    street: customer.street !== null ? customer.street : "",
                    houseNr: customer.house_num !== undefined && customer.house_num !== null ? customer.house_num : "",
                    stiege: customer.stiege !== undefined? customer.stiege : "",
                    top: customer.top && customer.top !== null ? customer.top : "",
                    zip: customer.zip !== null ? customer.zip : "",
                    city: customer.city !== null ? customer.city : "",
                    country_id: customer.country_id !== null && customer.country_id !== undefined ? customer.country_id : "12",
                    state_id: customer.state_id !== null ? customer.state_id : "",
        
                    x_account_owner: customer.company_type === "company" ? customer.name : `${customer.name} ${customer.last_name}`,
                    x_account_iban: '',
                    x_account_bic: '',
        
                    x_file_vollmacht_readed: false,
                    x_file_vollmacht: '',
                    x_file_ausweiskopie: '',
                    x_file_ausweiskopie_name: "",
                    x_file_ausweiskopie_pdf: false,
                    x_qr_password: customer.password,
                    x_salespartner_campaign_code: customer.x_salespartner_campaign_code,
                    x_salespartner_campaign_document: customer.x_salespartner_campaign_document,
            }});
        }
    }, [])

    if (Object.keys(data).length === 0) return <SplashPage />

    return (
        <Container>
            <Row className="mt-5">
                <Col xs="12">
                    <h3><span className="text-energo">ENERGO</span> Registrierung</h3>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12">
                    <IconContentCard variant={step === "!"? "error" : null} icon={
                        step === "!" ? <MdError size={50} /> :
                        step === 1 ? <BsDeviceSsd size={50} /> :
                        step === 2 ? <FaUser size={50} /> :
                        step === 3 ? <MdEditLocation size={50} /> :
                        step === 4 ? <MdAccountBalance size={50} /> :
                        step === 5 ? <FaFileSignature size={50} /> :
                        step === 6 ? <FaPassport size={50} /> :
                        step === 7 ? <GiPylon size={50} /> :
                        step === 8 ? <FaCheckCircle size={50} /> : null
                    }>
                        {step === "!" && <ServerErrorComponent data={data} error={apiError} setStep={setStep} />}
                        {step === 1 && <AnlagenComponent qr_code={data.qr_code} setData={setData} setStep={setStep} setError={setApiError} />}
                        {step === 2 && <PersonalComponent data={data} setData={setData} setStep={setStep} />}
                        {step === 3 && <AddressComponent data={data} setData={setData} setStep={setStep} />}
                        {step === 4 && <SepaComponent data={data} setData={setData} setStep={setStep} />}
                        {step === 5 && <SignatureComponent data={data} setData={setData} setStep={setStep} />}
                        {step === 6 && <PersonalIdComponent data={data} setData={setData} setStep={setStep} />}
                        {step === 7 && <ElvRegisterComponent data={data} setData={setData} setStep={setStep} errors={apiError} setErrors={setApiError} />}
                        {step === 8 && <DoneComponent data={data} setApiError={setApiError} setStep={setStep} />}
                    </IconContentCard>
                </Col>
            </Row>
        </Container>
    )
}
export default RegistrationPage;